import { Password } from '@mui/icons-material';
import { handleApiError } from '../core/apiError';
import axiosInstance from '../core/axiosInstance';
import { handleLogout } from './auth';


/**
 * Sends a request to the server to authenticate the user and log them in.
 * 
 * This function accepts the user's username and password, and sends a POST request 
 * to the login endpoint. The server response (such as the user token) will be returned.
 * It uses the default Axios instance with pre-configured headers and base URL.
 * 
 * @function
 * @returns {Promise<Object>} - A promise that resolves to the server's response data (e.g., user data or token).
 * @throws {Error} - Throws an error if the login request fails.
 * 
 */
export const getUserDetails = async () => {
    try {
        const response = await axiosInstance.get('/user/user-detail');
        return response?.data; // Server response, typically contains user data or token
    } catch (error) {
        handleApiError(error);
    }
};


export const updateUserName = async (payload) => {
    try {
        const response = await axiosInstance.put("/user/username", payload);
        return response?.data; // Server response, typically contains user data or token
    } catch (error) {
        handleApiError(error);
    }
};

export const updateUserContact = async (payload) => {
    try {
        const response = await axiosInstance.put("/user/user-contact", payload);
        return response?.data; // Server response, typically contains user data or token
    } catch (error) {
        handleApiError(error);
    }
};

export const updateUserAddress = async (payload) => {
    try {
        const response = await axiosInstance.put("/user/user-address", payload);
        return response?.data; // Server response, typically contains user data or token
    } catch (error) {
        handleApiError(error);
    }
};

export const updateUserCompany = async (payload) => {
    try {
        const response = await axiosInstance.put("/user/user-company", payload);
        return response?.data; // Server response, typically contains user data or token
    } catch (error) {
        handleApiError(error);
    }
};

export const updateUserPassword = async (payload) => {
    try {
        console.log("@@@@ payload :", payload)
        if (payload.new_password !== payload.confirm_password) {
            throw new Error("Password and Confirm Password do not match");
        }
        const newData = { password: payload.new_password }
        const response = await axiosInstance.put("/user/user-password", newData);
        handleLogout();
        return response?.data; // Server response, typically contains user data or token

    } catch (error) {
        handleApiError(error);
    }
};
